import Header from "../header/header";
import NavBar from "../nav/nav-bar";
import Footer from "../footer/footer";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import Service from "../webservice/http";
import ClipLoader from "react-spinners/ClipLoader";
import { BiError, BiCommentAdd, BiTaskX } from "react-icons/bi";
import { RiSignalWifiErrorFill, RiDeleteRow } from "react-icons/ri";
import Filter from "../filter";
import { FaFilter } from "react-icons/fa";
import { storage } from "../utils/storage";

/**
 * Short-label status tabs for quick filtering by collection_strategy.
 * Each entry maps an API value to a compact display label.
 */
const STATUS_TABS = [
  { key: "all", label: "All" },
  { key: "Complete Settlement", label: "Complete Settlement" },
  { key: "Partial Settlement", label: "Partial Settlement" },
  { key: "Promise Broken", label: "Promise Broken" },
  { key: "Denial", label: "Denial" },
  { key: "Legal Action", label: "Legal Action" },
];

const Promisetopay = () => {
  const history = useHistory();
  const role = storage.getItem("role");
  const isAgentRole =
    role === "Agent" ||
    role === "Agenth" ||
    role === "Agent Collections" ||
    role.includes("Agent");

  const useCase = storage.getItem("usecase") || "";
  const isCollectionUseCase = useCase.includes("Collections");

  const [leadList, setleadList] = useState(null);
  const [filterType, setFilterType] = useState("Organization");
  const [isPending, setIsPending] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState(
    isCollectionUseCase ? { collection_strategy: "Complete Settlement" } : {},
  );
  const [filterResetKey, setFilterResetKey] = useState(0);
  const [activeTab, setActiveTab] = useState(
    isCollectionUseCase ? "Complete Settlement" : "all",
  );
  const [tabSetStrategy, setTabSetStrategy] = useState(isCollectionUseCase);

  const services = new Service();

  /**
   * Fetch opportunity list
   */

  function fetchData() {
    setIsPending(true);
    setleadList(null);
    const baseUrl = isCollectionUseCase
      ? `api/call/promise_to_pay/`
      : `api/call/leads/`;

    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== "" && value != null) {
        if (Array.isArray(value)) {
          value.forEach((v) => params.append(key, v));
        } else {
          params.append(key, value);
        }
      }
    });
    const queryString = params.toString().replace(/\+/g, "%20");
    const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

    services.get(url).then((res) => {
      setIsPending(false);
      if (res == "TypeError: Failed to fetch") {
        setError("Connection Error");
      } else {
        try {
          if (res.code == "token_not_valid") {
            storage.clear();
            history.push("/login");
          }
          setleadList(res);
          setError(null);
        } catch (e) {
          setError(e);
        }
      }
    });
  }

  console.log(leadList);
  useEffect(() => {
    fetchData();
  }, [filterType, filters]);

  const [sideBarWidth, setSideBarWidth] = useState(0);
  const changeSideBarWidth = () => {
    if (sideBarWidth == 570) {
      setSideBarWidth(0);
    } else {
      setSideBarWidth(570);
    }
  };

  /**
   * Human-readable labels for filter keys shown in the pill banner.
   */
  const FILTER_LABEL_MAP = {
    collection_strategy: "Call Status",
    lob_name: "LOB",
    manager_name: "Manager",
    team_lead_name: "Team Lead",
    agent_name: "Agent",
    dca_organization_name: "DCA",
    from_date: "From",
    to_date: "To",
  };

  const handleFilterApply = (appliedFilters) => {
    setFilters(appliedFilters);
    // Sync the active tab if collection_strategy was set from the filter panel.
    // API values like 'Default-Promise Broken' contain the tab key 'Promise Broken',
    // so we do a case-insensitive suffix/exact match.
    if (appliedFilters.collection_strategy) {
      const stratVal = appliedFilters.collection_strategy.toLowerCase();
      const matchedTab = STATUS_TABS.find(
        (t) =>
          t.key !== "all" &&
          (stratVal === t.key.toLowerCase() ||
            stratVal.endsWith(t.key.toLowerCase())),
      );
      if (matchedTab) {
        setActiveTab(matchedTab.key);
      } else {
        setActiveTab("all");
      }
    } else {
      setActiveTab("all");
    }
    setTabSetStrategy(false);
  };

  const handleFilterReset = () => {
    setFilters(
      isCollectionUseCase ? { collection_strategy: "Complete Settlement" } : {},
    );
    setActiveTab(isCollectionUseCase ? "Complete Settlement" : "all");
    setTabSetStrategy(isCollectionUseCase);
    setFilterResetKey((k) => k + 1);
  };

  /**
   * When a status tab is clicked, update the collection_strategy filter.
   * Preserves any other active filters (date, agent, etc.).
   */
  const handleTabClick = (tabKey) => {
    setActiveTab(tabKey);
    if (tabKey === "all") {
      setTabSetStrategy(false);
      // Remove collection_strategy from filters, keep the rest
      setFilters((prev) => {
        const { collection_strategy, ...rest } = prev;
        return rest;
      });
    } else {
      setTabSetStrategy(true);
      setFilters((prev) => ({
        ...prev,
        collection_strategy: tabKey,
      }));
    }
  };

  /**
   * Compute filters to display in the banner.
   * Exclude collection_strategy when it was set via a tab click.
   */
  const displayFilters = Object.entries(filters).filter(
    ([key]) => !(key === "collection_strategy" && tabSetStrategy),
  );

  /**
   * Count of filters applied from the filter panel (shown as badge on funnel icon).
   * Always show all filter entries (tab-driven collection_strategy is always excluded).
   */
  const activeFilterCount = displayFilters.length;

  /** Renders the status tabs bar (only for collection use cases) */
  const StatusTabsBar = () => {
    if (!isCollectionUseCase) return null;
    return (
      <div className="bg-white px-10 py-4 mb-4 flex items-center justify-end">
        <span className="font-semibold text-2xl mx-3">Call Status :</span>
        <div
          className="flex flex-row shadow-lg"
          style={{
            overflow: "hidden",
            backgroundColor: "#f9f9f9",
            borderRadius: "8px",
          }}
        >
          {STATUS_TABS.map((tab, index) => (
            <button
              key={tab.key}
              className={`py-2 px-3 font-semibold transition-all duration-300 whitespace-nowrap ${
                activeTab === tab.key
                  ? "bg-blue-900 text-white"
                  : "bg-gray-100 text-gray-800 hover:bg-gray-200"
              }`}
              style={{
                borderRight:
                  index < STATUS_TABS.length - 1
                    ? "1px solid lightgray"
                    : "none",
              }}
              onClick={() => handleTabClick(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
    );
  };

  return isAgentRole ? (
    <div className="dashboard-body">
      <Header />
      <NavBar />

      <button
        onClick={changeSideBarWidth}
        title="Filters"
        style={{
          position: "fixed",
          transition: "0.5s",
          top: "35%",
          right: sideBarWidth > 0 ? sideBarWidth + 8 : 25,
          backgroundColor: activeFilterCount > 0 ? "#271078" : "#F99E52",
          color: "white",
          padding: "10px",
          height: "40px",
          width: "40px",
          zIndex: 2001,
          borderRadius: "10%",
          border: "none",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
        }}
      >
        <FaFilter size={18} />
        {activeFilterCount > 0 && (
          <span
            style={{
              position: "absolute",
              top: "-4px",
              right: "-4px",
              backgroundColor: "#F99E52",
              color: "#fff",
              borderRadius: "50%",
              width: "18px",
              height: "18px",
              fontSize: "10px",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {activeFilterCount}
          </span>
        )}
      </button>
      <Filter
        key={filterResetKey}
        width={sideBarWidth}
        changeSideBarWidth={changeSideBarWidth}
        filterType="opportunity"
        onApplyFilter={handleFilterApply}
        onresetFilter={handleFilterReset}
      />
      {sideBarWidth == 570 && (
        <div className="backdrop" style={{ zIndex: 1, height: "2500px" }}></div>
      )}

      <div className="container-fluid">
        <div className="my-call bg-white">
          <div className="my-calls-column">
            <div className="calls-top-pannel">
              <div className="row">
                <div className="col-lg-6">
                  <div className="pannel-heading clearfix">
                    <div className="pannel-heading-icon">
                      <i className="flaticon-incoming-call"></i>
                    </div>
                    <div className="pannel-heading-info">
                      {storage.getItem("usecase") ===
                        "Third Party Collection Agency" ||
                      storage.getItem("usecase") ===
                        "Banking Collections PCVC" ||
                      storage.getItem("usecase").includes("Collections") ? (
                        <p>Call Status</p>
                      ) : (
                        <p>Generated Opportunities </p>
                      )}

                      {storage.getItem("usecase") ===
                        "Third Party Collection Agency" ||
                      storage.getItem("usecase") ===
                        "Banking Collections PCVC" ||
                      storage.getItem("usecase").includes("Collections") ? (
                        <h3>
                          Resolution Status
                          <i className="icon-down-arrow-round"></i>
                        </h3>
                      ) : (
                        <h3>
                          Opportunities{" "}
                          <i className="icon-down-arrow-round"></i>
                        </h3>
                      )}
                    </div>
                  </div>
                  <div className="bradcums">
                    <ul className="clearfix">
                      <li>
                        {" "}
                        <i className="fa fa-circle" aria-hidden="true"></i>{" "}
                        {(leadList && leadList.data.length) || 0} Items
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <StatusTabsBar />

          {displayFilters.length > 0 && (
            <div
              style={{
                margin: "0 0 10px",
                padding: "8px 16px",
                backgroundColor: "#e8e3fa",
                borderLeft: "4px solid #271078",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "12px",
                flexWrap: "wrap",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "700",
                    color: "#271078",
                    marginRight: "4px",
                  }}
                >
                  Filters ({displayFilters.length}):
                </span>
                {displayFilters.map(([key, value]) => {
                  const label =
                    FILTER_LABEL_MAP[key] ||
                    key
                      .replace(/_/g, " ")
                      .replace(/\b\w/g, (c) => c.toUpperCase());
                  const displayVal = Array.isArray(value)
                    ? value.join(", ")
                    : value;
                  return (
                    <span
                      key={key}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        backgroundColor: "#f2effa",
                        border: "1px solid #dcd4f5",
                        borderRadius: "20px",
                        padding: "4px 12px",
                        color: "#271078",
                        fontSize: "13px",
                        fontWeight: "600",
                        gap: "6px",
                      }}
                    >
                      {label}: {displayVal}
                    </span>
                  );
                })}
              </div>
              <button
                onClick={handleFilterReset}
                style={{
                  background: "none",
                  border: "1px solid #271078",
                  borderRadius: "20px",
                  color: "#271078",
                  fontSize: "12px",
                  fontWeight: "700",
                  padding: "4px 14px",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                Clear All
              </button>
            </div>
          )}
          {/* <div
            className=" flex justify-end px-10 h-20 items-center mb-1 mt-2 gap-4 mr-14"
            style={{ paddingBottom: "6px" }}
          >
            <label
              htmlFor="filter-type"
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#333",
                marginBottom: "0px",
              }}
            >
              View By:
            </label>
            <select
              id="filter-type"
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              style={{
                border: "none",
                background: "#eef2f5",
                borderRadius: "10px",
                width: "180px",
                outline: "none",
                paddingLeft: "8px",
                height: "37px",
                cursor: "pointer",
                fontSize: "14px",
                color: "#333",
              }}
            >
              <option value="organization">Organization</option>
              <option value="dca">DCA</option>
            </select>
          </div> */}

          <div className="call-table">
            <table className="ss">
              {!isCollectionUseCase ? (
                <thead>
                  <tr>
                    <th>
                      <p>Call Date</p>
                    </th>
                    <th>
                      <p>Customer</p>
                    </th>
                    <th>
                      <p>Product</p>
                    </th>
                    <th>
                      <p>Call Type</p>
                    </th>
                    <th>
                      <p>Sentiments</p>
                    </th>
                    <th>
                      <p>Intent</p>
                    </th>
                  </tr>
                </thead>
              ) : (
                <thead>
                  <tr>
                    <th>
                      <p>Call Date</p>
                    </th>
                    <th>
                      <p>Customer</p>
                    </th>
                    <th>
                      <p>Agent</p>
                    </th>

                    <th>
                      <p>Language</p>
                    </th>
                    <th>
                      <p>Product</p>
                    </th>
                    <th>
                      <p>Call Category</p>
                    </th>
                    <th>
                      <p>Collection Status</p>
                    </th>
                    <th>
                      <p>Collection Score</p>
                    </th>
                    <th>
                      <p>Collected</p>
                    </th>
                    <th className=" whitespace-nowrap">
                      <p>Target</p>
                    </th>
                  </tr>
                </thead>
              )}

              {isPending && (
                <tr>
                  <td
                    colSpan="10"
                    style={{ height: "400px", textAlign: "center", verticalAlign: "middle" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                      }}
                    >
                      <ClipLoader color="#2056FF" size={50} />
                    </div>
                  </td>
                </tr>
              )}

              {error && (
                <tr
                  style={{ textAlignVertical: "center", textAlign: "center" }}
                >
                  <td colSpan="6">
                    <p style={{ fontSize: "25px", color: "#FF8520" }}>
                      {error === "Connection Error" && (
                        <RiSignalWifiErrorFill />
                      )}
                      {error !== "Connection Error" && <BiError />}
                      {error}
                    </p>
                  </td>
                </tr>
              )}

              {!isCollectionUseCase ? (
                <tbody>
                  {leadList?.data?.length > 0
                    ? leadList.data.map((lead) => (
                        <tr
                          key={lead._id}
                          onClick={() =>
                            history.push(`/call/${lead._id}/promise-details`)
                          }
                          className=" cursor-pointer"
                        >
                          <td>
                            <div className="select-check">{lead._date}</div>
                          </td>
                          <td>{lead._customer}</td>
                          <td>{lead._product_name}</td>
                          <td>{lead._status}</td>
                          <td>
                            {lead._sentiment > 0 ? (
                              <p className="red" style={{ color: "green" }}>
                                <i
                                  className="fa fa-plus-circle"
                                  aria-hidden="true"
                                />
                              </p>
                            ) : (
                              <p className="red" style={{ color: "red" }}>
                                <i
                                  className="fa fa-minus-circle"
                                  aria-hidden="true"
                                />
                              </p>
                            )}
                          </td>
                          <td>
                            {lead._intent > 0 ? (
                              <p className="red" style={{ color: "green" }}>
                                <i
                                  className="fa fa-plus-circle"
                                  aria-hidden="true"
                                />
                              </p>
                            ) : (
                              <p className="red" style={{ color: "red" }}>
                                <i
                                  className="fa fa-minus-circle"
                                  aria-hidden="true"
                                />
                              </p>
                            )}
                            <div className="select-pop-up">
                              <div className="dropdown">
                                <button
                                  className="btn btn-primary dropdown-toggle"
                                  type="button"
                                  data-toggle="dropdown"
                                >
                                  {" "}
                                  <i className="icon-down-arrow-round"></i>
                                </button>
                                <ul className="dropdown-menu">
                                  <li>
                                    <a href="#">
                                      Category&nbsp; : {lead._category}
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#">Agent&nbsp; : {lead._agent}</a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))
                    : !isPending && (
                        <tr>
                          <td
                            colSpan="6"
                            style={{ textAlign: "center", padding: "20px" }}
                          >
                            No records found
                          </td>
                        </tr>
                      )}
                </tbody>
              ) : (
                <tbody>
                  {leadList?.data?.length > 0 &&
                    leadList.data.map((lead) => (
                      <tr
                        key={lead._id}
                        onClick={() =>
                          history.push(`/call/${lead._id}/promise-details`)
                        }
                        className=" cursor-pointer"
                      >
                        <td>{lead._date || "-"}</td>
                        <td>{lead._customer || "-"}</td>

                        <td>{lead._agent || "-"}</td>
                        <td>{lead._language || "-"}</td>
                        <td>{lead._product_name || "-"}</td>
                        <td>{lead._due_category || "-"}</td>
                        <td>{lead._call_collection_status || "-"}</td>
                        <td>{lead._call_collection_score || "-"}</td>

                        <td>{lead._collected_amount_formatted || "-"}</td>
                        <td>{lead._target_amount_formatted || "-"}</td>
                      </tr>
                    ))}
                  {(!leadList || leadList.data?.length === 0) && !isPending && (
                    <tr>
                      <td
                        colSpan="9"
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        No records found
                      </td>
                    </tr>
                  )}
                </tbody>
              )}
            </table>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  ) : (
    <div className="dashboard-body">
      <Header />
      <NavBar />

      <button
        onClick={changeSideBarWidth}
        title="Filters"
        style={{
          position: "fixed",
          transition: "0.5s",
          top: "33%",
          right: sideBarWidth > 0 ? sideBarWidth + 8 : 25,
          backgroundColor: activeFilterCount > 0 ? "#271078" : "#F99E52",
          color: "white",
          padding: "10px",
          height: "40px",
          width: "40px",
          zIndex: 2001,
          borderRadius: "10%",
          border: "none",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
        }}
      >
        <FaFilter size={18} />
        {activeFilterCount > 0 && (
          <span
            style={{
              position: "absolute",
              top: "-4px",
              right: "-4px",
              backgroundColor: "#F99E52",
              color: "#fff",
              borderRadius: "50%",
              width: "18px",
              height: "18px",
              fontSize: "10px",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {activeFilterCount}
          </span>
        )}
      </button>
      <Filter
        key={filterResetKey}
        width={sideBarWidth}
        changeSideBarWidth={changeSideBarWidth}
        filterType="opportunity"
        onApplyFilter={handleFilterApply}
        onresetFilter={handleFilterReset}
      />
      {sideBarWidth == 570 && (
        <div className="backdrop" style={{ zIndex: 1, height: "2500px" }}></div>
      )}

      <div className="container-fluid">
        <div className="my-call bg-white">
          <div className="my-calls-column">
            <div className="calls-top-pannel">
              <div className="row">
                <div className="col-lg-6">
                  <div className="pannel-heading clearfix">
                    <div className="pannel-heading-icon">
                      <i className="flaticon-incoming-call"></i>
                    </div>
                    <div className="pannel-heading-info">
                      {storage.getItem("usecase") ===
                        "Third Party Collection Agency" ||
                      storage.getItem("usecase") ===
                        "Banking Collections PCVC" ||
                      storage.getItem("usecase").includes("Collections") ? (
                        <p>Call Status</p>
                      ) : (
                        <p>Generated Opportunities </p>
                      )}

                      {storage.getItem("usecase") ===
                        "Third Party Collection Agency" ||
                      storage.getItem("usecase") ===
                        "Banking Collections PCVC" ||
                      storage.getItem("usecase").includes("Collections") ? (
                        <h3>
                          Resolution Status
                          <i className="icon-down-arrow-round"></i>
                        </h3>
                      ) : (
                        <h3>
                          Opportunities{" "}
                          <i className="icon-down-arrow-round"></i>
                        </h3>
                      )}
                    </div>
                  </div>
                  <div className="bradcums">
                    <ul className="clearfix">
                      <li>
                        {" "}
                        <i className="fa fa-circle" aria-hidden="true"></i>{" "}
                        {leadList && leadList.data.length} Items
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <StatusTabsBar />

          {displayFilters.length > 0 && (
            <div
              style={{
                margin: "0 0 10px",
                padding: "8px 16px",
                backgroundColor: "#e8e3fa",
                borderLeft: "4px solid #271078",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "12px",
                flexWrap: "wrap",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "700",
                    color: "#271078",
                    marginRight: "4px",
                  }}
                >
                  Filters ({displayFilters.length}):
                </span>
                {displayFilters.map(([key, value]) => {
                  const label =
                    FILTER_LABEL_MAP[key] ||
                    key
                      .replace(/_/g, " ")
                      .replace(/\b\w/g, (c) => c.toUpperCase());
                  const displayVal = Array.isArray(value)
                    ? value.join(", ")
                    : value;
                  return (
                    <span
                      key={key}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        backgroundColor: "#f2effa",
                        border: "1px solid #dcd4f5",
                        borderRadius: "20px",
                        padding: "4px 12px",
                        color: "#271078",
                        fontSize: "13px",
                        fontWeight: "600",
                        gap: "6px",
                      }}
                    >
                      {label}: {displayVal}
                    </span>
                  );
                })}
              </div>
              <button
                onClick={handleFilterReset}
                style={{
                  background: "none",
                  border: "1px solid #271078",
                  borderRadius: "20px",
                  color: "#271078",
                  fontSize: "12px",
                  fontWeight: "700",
                  padding: "4px 14px",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                Clear All
              </button>
            </div>
          )}

          <div className="call-table">
            <table className="ss">
              {!isCollectionUseCase ? (
                <thead>
                  <tr>
                    <th>
                      <p>Call Date</p>
                    </th>
                    <th>
                      <p>Customer</p>
                    </th>
                    <th>
                      <p>Product</p>
                    </th>
                    <th>
                      <p>Call Type</p>
                    </th>
                    <th>
                      <p>Sentiments</p>
                    </th>
                    <th>
                      <p>Intent</p>
                    </th>
                  </tr>
                </thead>
              ) : (
                <thead>
                  <tr>
                    <th>
                      <p>Call Date</p>
                    </th>
                    <th>
                      <p>Customer</p>
                    </th>
                    <th>
                      <p>Agent</p>
                    </th>

                    <th>
                      <p>Language</p>
                    </th>
                    <th>
                      <p>Product</p>
                    </th>
                    <th>
                      <p>Call Category</p>
                    </th>
                    <th>
                      <p>Collection Status</p>
                    </th>
                    <th>
                      <p>Collection Score</p>
                    </th>
                    <th>
                      <p>Collected</p>
                    </th>
                    <th className=" whitespace-nowrap">
                      <p>Target</p>
                    </th>
                  </tr>
                </thead>
              )}

              {isPending && (
                <tr>
                  <td
                    colSpan="10"
                    style={{ height: "400px", textAlign: "center", verticalAlign: "middle" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                      }}
                    >
                      <ClipLoader color="#2056FF" size={50} />
                    </div>
                  </td>
                </tr>
              )}

              {error && (
                <tr
                  style={{ textAlignVertical: "center", textAlign: "center" }}
                >
                  <td colSpan="6">
                    <p style={{ fontSize: "25px", color: "#FF8520" }}>
                      {error === "Connection Error" && (
                        <RiSignalWifiErrorFill />
                      )}
                      {error !== "Connection Error" && <BiError />}
                      {error}
                    </p>
                  </td>
                </tr>
              )}

              {!isCollectionUseCase ? (
                <tbody>
                  {leadList &&
                    leadList.data.map((lead) => (
                      <tr
                        key={lead._id}
                        onClick={() =>
                          history.push(`/call/${lead._id}/call-status-details`)
                        }
                      >
                        <td>
                          <div className="select-check">{lead._date}</div>
                        </td>
                        <td>{lead._customer}</td>
                        <td>{lead._product_name}</td>
                        <td>{lead._status}</td>
                        <td>
                          {lead._sentiment > 0 ? (
                            <p className="red" style={{ color: "green" }}>
                              <i
                                className="fa fa-plus-circle"
                                aria-hidden="true"
                              />
                            </p>
                          ) : (
                            <p className="red" style={{ color: "red" }}>
                              <i
                                className="fa fa-minus-circle"
                                aria-hidden="true"
                              />
                            </p>
                          )}
                        </td>
                        <td>
                          {lead._intent > 0 ? (
                            <p className="red" style={{ color: "green" }}>
                              <i
                                className="fa fa-plus-circle"
                                aria-hidden="true"
                              />
                            </p>
                          ) : (
                            <p className="red" style={{ color: "red" }}>
                              <i
                                className="fa fa-minus-circle"
                                aria-hidden="true"
                              />
                            </p>
                          )}
                          <div className="select-pop-up">
                            <div className="dropdown">
                              <button
                                className="btn btn-primary dropdown-toggle"
                                type="button"
                                data-toggle="dropdown"
                              >
                                {" "}
                                <i className="icon-down-arrow-round"></i>
                              </button>
                              <ul className="dropdown-menu">
                                <li>
                                  <a href="#">
                                    Category&nbsp; : {lead._category}
                                  </a>
                                </li>
                                <li>
                                  <a href="#">Agent&nbsp; : {lead._agent}</a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              ) : (
                <tbody>
                  {leadList?.data?.length > 0 &&
                    leadList.data.map((lead) => (
                      <tr
                        key={lead._id}
                        onClick={() =>
                          history.push(`/call/${lead._id}/call-status-details`)
                        }
                      >
                        <td>{lead._date}</td>
                        <td>{lead._customer}</td>
                        <td>{lead._agent}</td>
                        <td>{lead._language}</td>
                        <td>{lead._product_name || "-"}</td>
                        <td>{lead._due_category || "-"}</td>
                        <td>{lead._dataklout_collection_view || "-"}</td>
                        <td>{lead._call_collection_score || "-"}</td>
                        <td>{lead._collected_amount_formatted || "-"}</td>
                        <td>{lead._target_amount_formatted || "-"}</td>
                      </tr>
                    ))}
                  {(!leadList || leadList.data?.length === 0) && !isPending && (
                    <tr>
                      <td
                        colSpan="9"
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        No records found
                      </td>
                    </tr>
                  )}
                </tbody>
              )}
            </table>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Promisetopay;
